import React, { useEffect, useState } from "react";
import MealDataCards from "./MealDataCards";
import { apiClient } from "../services/apiClient";

export default function MealDataFetcher({ subCategoryId }) {
  const [products, setProducts] = useState([]);

  const fetchProducts = async () => {
    try {
      const productData = await apiClient.get("/product/", {
        params: { firm: 3, sub_category: subCategoryId, is_active: true },
      });
      setProducts(productData);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  useEffect(() => {
    //   console.log("Subcategory ID:", subCategoryId) // Debugging subCategoryId
    if (subCategoryId) {
      fetchProducts();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subCategoryId]);

  return <MealDataCards items={products} />;
}
